import { render, staticRenderFns } from "./BirthFrom.vue?vue&type=template&id=58d42200"
import script from "./BirthFrom.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthFrom.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports